import React, { useState, useEffect } from "react"
import UserProfile from "components/UserProfile/UserProfile"
import API from "components/Apis/API";
import { Container } from "react-bootstrap"

function Maps() {
  const [data, setData] = useState()

  const fetchData = async () => {
    const url = "" + "admin/get_map_data"
    const token = await UserProfile.getToken()
    const response = API.postData(url,{})
    const data = response
    setData(data.message)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return <Container>{data}</Container>
}

export default Maps
